import { Icon } from '../ui/Icon';
import { useShared } from './Layout';
import { localizedPath } from '../../i18n/path';
import { t } from '../../i18n/t';

/** Mobile only action bar; the application page has its own submit button. */
export function StickyCta() {
  const { brand } = useShared();

  return (
    <div className="fixed inset-x-0 bottom-0 z-30 border-t border-gray-200 bg-white/95 p-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] backdrop-blur lg:hidden">
      <div className="flex items-center gap-3">
        <a
          href={localizedPath('/pieteikums')}
          className="flex min-h-12 flex-1 items-center justify-center gap-2 rounded-xl bg-accent-500 px-4 text-base font-semibold text-white hover:bg-accent-600"
        >
          {t('ui.cta.apply')}
          <Icon name="arrow-right" className="h-5 w-5" strokeWidth={2} />
        </a>
        <a
          href={brand.phoneHref}
          aria-label={t('ui.cta.call', { phone: brand.phone })}
          className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl text-primary-500 ring-1 ring-inset ring-gray-200 hover:bg-gray-50"
        >
          <Icon name="phone" className="h-5 w-5" />
        </a>
      </div>
    </div>
  );
}
